export enum PRODUCTS_TYPE {
  SHARED_SPACE = "1",
  MEETING_ROOM = "4",
  EVENTS = "5",
  PRIVATE = "6",
  EXCLUSIVE = "3",
}
